import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const APPROVE_ONE_DEPOSIT = gql`
    mutation(
        $id: String!
    ) {
        approveOneDeposit (id: $id) {
            ...TransactionInfo
        }
    }
    ${TransactionFragment}
`;